
import React from 'react';
import { createRoot } from 'react-dom/client';
import JFBApp from './JFBApp';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './registerServiceWorker';

const root = createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<JFBApp/>
	</BrowserRouter>
);

serviceWorker.unregister();